import gql from 'graphql-tag';

export default gql`
  subscription onUpdateItem {
    onUpdateItem {
      id
      title
      price
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/graphql/subscriptions/UpdateItemSubscription.ts